import { TimeSlot } from "common";

export default class AppointmentNotLockedError extends Error {
    constructor(public appointment: TimeSlot) {
        super("The appointment could not be locked");
    }
}
